import styled from "@emotion/styled";
import { Modal } from "scmp-sdk/components/modal";
import { Backdrop } from "scmp-sdk/components/modal/backdrop/styles";
import { SwiperSlide } from "swiper/react";

import { theme } from "shared/lib/styles";

import { Swiper } from "scmp-app/components/swiper";

import ArrowButtonIcon from "./arrow-button.svg?url";
import CloseButtonIcon from "./close-button.svg";

export const VideoBackdrop = styled(Backdrop)`
  background-color: #000000;

  opacity: 0.9;
`;

export const StyledModal = styled(Modal)`
  inline-size: 100vw;
  block-size: 100dvh;
`;

export const Container = styled.div`
  position: relative;

  inline-size: 100%;
  block-size: 100dvh;

  &.swiper-button-disabled {
    display: none;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  z-index: 10;

  display: none;
  justify-content: center;
  align-items: center;

  border-radius: 100px;

  background-color: #000000;

  cursor: pointer;
  ${theme.breakpoints.up("tablet")} {
    inset-block-start: 56px;
    inset-inline-start: 32px;

    display: flex;

    inline-size: 64px;
    block-size: 64px;
    padding: 14px;
  }
`;

export const StyledCloseButtonIcon = styled(CloseButtonIcon)`
  display: block;

  inline-size: 18px;
  block-size: 18px;

  ${theme.breakpoints.up("tablet")} {
    inline-size: 36px;
    block-size: 36px;
  }
`;

type NavButtonProps = {
  $direction: "bottom" | "top";
};

export const NavButton = styled.button<NavButtonProps>`
  position: absolute;
  inset-block-start: ${props =>
    props.$direction === "top" ? "calc( 50% - 40px )" : "calc( 50% + 40px )"};
  inset-inline-end: 27px;
  z-index: 10;

  display: none;

  inline-size: 64px;
  block-size: 64px;
  padding: 7px;

  border: none;
  border-radius: 100px;

  background: url(${ArrowButtonIcon}) no-repeat center;
  background-color: #000000;
  background-position: center;
  background-size: 48px 48px;

  cursor: pointer;

  transform: ${props => (props.$direction === "bottom" ? "rotate(180deg)" : "none")};

  ${theme.breakpoints.up("tablet")} {
    display: block;
  }
`;

export const StyledSwiperSlide = styled(SwiperSlide)`
  &.swiper-slide {
    display: flex;
    justify-content: center;
    align-items: center;

    block-size: auto !important;
    padding-block-start: 0;

    scroll-snap-stop: always;
  }
`;

export const StyledSwiper = styled(Swiper)`
  inline-size: 100%;
  block-size: 100%;

  .swiper-wrapper {
    ${theme.breakpoints.up("tablet")} {
      scroll-padding-block-start: 56px;
    }
  }
`;

export const SwiperWrapper = styled.div`
  inline-size: 100%;
  block-size: 100%;

  .swiper-button-disabled {
    visibility: hidden;
  }
`;
